/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/factory1.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube059.geometry}
				material={materials["Material.005"]}
				position={[2.224, -0.289, 0.784]}
				scale={[1, 0.738, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder020.geometry}
				material={materials["Material.005"]}
				position={[2.224, 0.562, 0.784]}
				scale={[0.079, 0.455, 0.079]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube060.geometry}
				material={materials["Material.005"]}
				position={[2.224, -0.289, 1.266]}
				scale={[1, 0.738, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder021.geometry}
				material={materials["Material.005"]}
				position={[2.224, 0.562, 1.266]}
				scale={[0.079, 0.455, 0.079]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath007.geometry}
				material={materials["Material.005"]}
				position={[-0.505, -0.044, -1.856]}
				rotation={[Math.PI, 0, Math.PI / 2]}
				scale={0.148}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath008.geometry}
				material={materials["Material.005"]}
				position={[-0.505, -0.044, -1.685]}
				rotation={[Math.PI, 0, Math.PI / 2]}
				scale={0.148}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube046.geometry}
				material={materials["Material.005"]}
				position={[0.012, -0.354, 0.4]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube048.geometry}
				material={materials["Material.005"]}
				position={[-1.512, -0.108, -1.52]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube051.geometry}
				material={materials["Material.005"]}
				position={[0.341, -0.077, 0.377]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube052.geometry}
				material={materials["Material.005"]}
				position={[-0.34, -0.068, 0.31]}
				scale={[0.275, 0.258, 1.125]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube053.geometry}
				material={materials["Material.005"]}
				position={[1.853, 0.028, -0.942]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube054.geometry}
				material={materials["Material.005"]}
				position={[-0.089, -0.11, 1.872]}
				scale={[0.016, 0.035, 0.022]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube055.geometry}
				material={materials["Material.005"]}
				position={[-2.325, 0.305, -1.708]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube056.geometry}
				material={materials["Material.005"]}
				position={[0.34, -0.022, -1.741]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube057.geometry}
				material={materials["Material.005"]}
				position={[0.307, 0.521, 0.392]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube058.geometry}
				material={materials["Material.005"]}
				position={[1.719, -0.173, 2.297]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane006.geometry}
				material={materials["Material.005"]}
				position={[0.77, 0.131, -0.637]}
				scale={[0.146, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane007.geometry}
				material={materials["Material.005"]}
				position={[0.347, 0.131, -0.637]}
				scale={[0.146, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane009.geometry}
				material={materials["Material.005"]}
				position={[-0.083, 0.131, -0.637]}
				scale={[0.146, 1, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube061.geometry}
				material={materials["Material.005"]}
				position={[-0.472, 0.352, -0.494]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube062.geometry}
				material={materials["Material.005"]}
				position={[0.987, 0.352, -0.494]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder022.geometry}
				material={materials["Material.005"]}
				position={[-1.527, 0.49, 0.316]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube063.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, 0.316]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder023.geometry}
				material={materials["Material.005"]}
				position={[-1.283, 0.27, 0.316]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube064.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, 0.667]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube065.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, -0.043]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder024.geometry}
				material={materials["Material.005"]}
				position={[-1.527, 0.49, 2.382]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube066.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, 2.382]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder025.geometry}
				material={materials["Material.005"]}
				position={[-1.283, 0.27, 2.382]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube067.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, 2.732]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube068.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, 2.023]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder026.geometry}
				material={materials["Material.005"]}
				position={[-1.527, 0.49, -1.694]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube069.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, -1.694]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder027.geometry}
				material={materials["Material.005"]}
				position={[-1.283, 0.27, -1.694]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.14, 0.269, 0.14]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube070.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, -1.343]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube071.geometry}
				material={materials["Material.005"]}
				position={[-1.391, 0.358, -2.053]}
				scale={[0.273, 0.273, 0.011]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube072.geometry}
				material={materials["Material.005"]}
				position={[0.097, -0.147, 2.97]}
			/>
			<group
				position={[0.129, 0.548, 0.586]}
				rotation={[0, 0.836, 0]}
				scale={0.608}
			>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane012.geometry}
					material={materials["Material.003"]}
				/>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane012_1.geometry}
					material={materials["Material.006"]}
				/>
			</group>
		</group>
	);
}

useGLTF.preload("models/factory1.glb");
